import React from 'react';
import { useLocaleState } from 'react-admin';
import { getEventStatus } from '../../utils/formatting';
import { formatDateValue } from '../../utils/dateUtils';
import EmptyStateImage from '../../assets/empty-state.png';
import { resolveMediaUrl } from '../../utils/mediaUrl';

const EventHeader = ({ event }) => {
  const [locale] = useLocaleState();
  if (!event) return null;

  const eventStatus = getEventStatus(event);
  const bannerSrc = event.banner?.src
    ? resolveMediaUrl(event.banner.src)
    : EmptyStateImage;
  const startLabel = formatDateValue(event.startdate, 'LL', locale);

  return (
    <>
      {/* Poster */}
      <div style={{ marginBottom: 50 }}>
        <img
          src={bannerSrc}
          alt={event.name}
          style={{ width: 280, height: 350, objectFit: 'cover', borderRadius: 5 }}
        />
      </div>

      <h2>
        {event.name}
        {startLabel && startLabel !== 'N/A' ? ` - ${startLabel}` : ''} /
        <span style={{ fontSize: 18, color: eventStatus.color }}>{eventStatus.label}</span>
      </h2>
    </>
  );
};

export default EventHeader;
